import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose"; // @flow

import React from 'react';
import DefaultTheme from './theme';
/*::
import type { Node } from 'react';
import type { BreadcrumbsThemeType } from './theme';

export type LinkType = {|
  label: string,
  url?: string,
|};

type Props = {|
  home?: LinkType,
  links?: Array<LinkType>,
  linkComponent?: Node,
  splitter?: string,
  splitterIcon?: string;
  rootIcon?: string;
  theme?: BreadcrumbsThemeType,
  rest?: any,
|};
*/

var Breadcrumbs = function Breadcrumbs(_ref
/*: Props */
) {
  var _ref$home = _ref.home,
      home = _ref$home === void 0 ? {
    label: 'Home',
    url: '/'
  } : _ref$home,
      _ref$links = _ref.links,
      links = _ref$links === void 0 ? [{
    label: 'Current Page'
  }] : _ref$links,
      _ref$linkComponent = _ref.linkComponent,
      linkComponent = _ref$linkComponent === void 0 ? 'a' : _ref$linkComponent,
      _ref$splitter = _ref.splitter,
      splitter = _ref$splitter === void 0 ? ' / ' : _ref$splitter,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? DefaultTheme : _ref$theme,
      splitterIcon = _ref.splitterIcon,
      rootIcon = _ref.rootIcon,
      rest = _objectWithoutPropertiesLoose(_ref, ["home", "links", "linkComponent", "splitter", "theme", "splitterIcon", "rootIcon"]);

  return /*#__PURE__*/React.createElement(theme.Main, Object.assign({
    "data-test": "breadcrumbs-main"
  }, rest), /*#__PURE__*/React.createElement(theme.Link, {
    to: home.url,
    href: home.url,
    as: linkComponent
  }, rootIcon ? /*#__PURE__*/React.createElement(theme.RootIcon, {
    src: rootIcon,
    alt: ""
  }) : home.label), links.map(function (link) {
    return /*#__PURE__*/React.createElement(theme.LinkWrapper, {
      key: (link.label || '') + "-" + (link.url || '')
    }, splitterIcon ? /*#__PURE__*/React.createElement(theme.SplitterIcon, {
      src: splitterIcon,
      alt: ""
    }) : splitter, link.url ? /*#__PURE__*/React.createElement(theme.Link, {
      to: link.url,
      href: link.url,
      as: linkComponent,
      "data-test": "breadcrumbs-link"
    }, link.label) : /*#__PURE__*/React.createElement(theme.Inactive, {
      "data-test": "breadcrumbs-inactive"
    }, link.label));
  }));
};

export default Breadcrumbs;